import React, {Fragment, useState, useEffect} from 'react'
import axios from 'axios';
import { Container,ContenedorRespuesta} from './styles'
import globals from 'react-global-configuration';

export const Respuestas = (props) => { 
    
    const _URL_REST = globals.get('_URL_REST');
    

    const [data, setData] = useState(null);
    


    useEffect(() => {
        async function fetchData() {
          // You can await here
          const result = await axios(
            `${_URL_REST}/getrespuestas/${props.idpregunta}`,
        );
        setData(result.data);
          //console.log('data',result.data)
        }
        fetchData();
    }, [_URL_REST]);

    if (!data) {
        return <div></div>  
    }

 
    

    return (
        <Fragment>
                    {
                        
                        data
                        .map(item => 
                            <ContenedorRespuesta key={'key'+item.id}>
                                {item.estexto === null ? 
                                    <>
                                    <input onChange={()=>{ props.questionChange(props.idpregunta,item.id); }} type="radio" id={`test-${item.id}`} name={`radio-group-${props.idpregunta}`} required  />
                                    <label htmlFor={`test-${item.id}`}>{item.texto}</label>
                                    </>
                                    :
                                    <>
                                    <div><label htmlFor={`test-${item.id}`}>{item.texto}</label></div>
                                    <div><textarea  id={`test-${item.id}`} rows="8" cols="90" onChange={(e)=>{ props.questionChange(props.idpregunta,item.id,1,e.target.value); }} name={`radio-group-${props.idpregunta}`} required>Comentario: </textarea></div>
                                    </>
                                }
                                
                            </ContenedorRespuesta>
                            
                        )
                    }
                    
        </Fragment>
    )
}
